import React from 'react';
import './Footer.css'

export default function Footer() {
	return (
		<footer>
			<p>Copyright <span className='narrow-type'>&copy;</span> 2020 Zacharia Lutz. All Rights Reserved.</p>
		</footer>
	)
}